// note: this file is for frontend validation only
// backend validation are handled separately
import { cleanRegNo } from "./purchase-car";
import FIELD_ERROR_MESSAGE from "./errorMessages";
interface NameErrorType {
  name?: string;
}
interface EmailErrorsTypes {
  email?: string;
}

interface EmailSendQuoteErrorsTypes {
  email?: string;
}

interface PhoneNumberErrorsTypes {
  phoneNumber?: string;
}

interface PhoneNumberSendQuoteErrorsTypes {
  phoneNumber?: string;
}
interface PhoneNumberOptionalErrorsTypes {
  phoneNumberOptional?: string;
}

interface CarNumberErrorsTypes {
  carNumber?: string;
}

interface EngineNumberErrorsTypes {
  engineNumber?: string;
}

interface BikeNumberErrorsTypes {
  bikeNumber?: string;
}

interface ChassisNumberErrorsTypes {
  chassisNumber?: string;
}

interface PinCodeErrorsTypes {
  pinCode?: string;
}

interface PanNumberErrorsTypes {
  panNumber?: string;
}

interface OTPErrorsTypes {
  otp?: string;
}

interface ValueInterface {
  [props: string]: any;
}
interface GSTErrorsTypes {
  gstNumber?: string;
}

const validate = {
  name(values: ValueInterface) {
    const { name } = values;
    const errors: NameErrorType = {};
    if (!name) {
      errors.name = FIELD_ERROR_MESSAGE.name.required;
    } else if (!/^[a-zA-Z ]{2,60}$/.test(values.name)) {
      errors.name = FIELD_ERROR_MESSAGE.name.invalid;
    }
    return errors;
  },
  panNumber(values: ValueInterface) {
    const errors: PanNumberErrorsTypes = {};
    const panNumberRegex = "^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$";
    const tanNumberRegex = "^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$";
    if (!values.panNumber) {
      errors.panNumber = FIELD_ERROR_MESSAGE.pan.required;
    } else if (
      !new RegExp(panNumberRegex, "i").test(values.panNumber) &&
      !new RegExp(tanNumberRegex, "i").test(values.panNumber)
    ) {
      errors.panNumber = FIELD_ERROR_MESSAGE.pan.invalid;
    }
    return errors;
  },
  email(values: ValueInterface) {
    const errors: EmailErrorsTypes = {};

    if (!values.email) {
      errors.email = FIELD_ERROR_MESSAGE.email.required;
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email.trim())
    ) {
      errors.email = FIELD_ERROR_MESSAGE.email.invalid;
    }
    return errors;
  },
  emailSendQuote(values: ValueInterface) {
    const errors: EmailSendQuoteErrorsTypes = {};

    if (!values.email) {
      errors.email = FIELD_ERROR_MESSAGE.email.required;
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email?.trim())
    ) {
      errors.email = FIELD_ERROR_MESSAGE.email.invalid;
    }
    return errors;
  },
  phoneNumber(values: ValueInterface) {
    const errors: PhoneNumberErrorsTypes = {};

    if (!values.phoneNumber) {
      errors.phoneNumber = FIELD_ERROR_MESSAGE.contactNumber.required;
    } else if (!/^[6-9]\d{9}$/i.test(values.phoneNumber?.toString()?.trim())) {
      errors.phoneNumber = FIELD_ERROR_MESSAGE.mobile.invalid;
    }
    return errors;
  },
  phoneNumberSendQuote(values: ValueInterface) {
    const errors: PhoneNumberSendQuoteErrorsTypes = {};

    if (!values.phoneNumber) {
      errors.phoneNumber = FIELD_ERROR_MESSAGE.mobile.required;
    } else if (!/^[6-9]\d{9}$/i.test(values.phoneNumber?.toString()?.trim())) {
      errors.phoneNumber = FIELD_ERROR_MESSAGE.mobile.invalid;
    }
    return errors;
  },
  phoneNumberOptional(values: ValueInterface) {
    const errors: PhoneNumberOptionalErrorsTypes = {};
    if (!values.phoneNumberOptional) {
      return null;
    }
    if (!/^[6-9]\d{9}$/i.test(values.phoneNumberOptional)) {
      errors.phoneNumberOptional = FIELD_ERROR_MESSAGE.mobile.invalid;
    }
    return errors;
  },
  otp(values: ValueInterface) {
    const errors: OTPErrorsTypes = {};
    if (!values.otp) {
      errors.otp = FIELD_ERROR_MESSAGE.otp.required;
    } else if (!/(^$)|(^\d+$)/.test(values.otp) || values?.otp?.length !== 4) {
      errors.otp = FIELD_ERROR_MESSAGE.otp.invalid;
    }
    return errors;
  },
  vehicleNumber(values: ValueInterface, type: String) {
    var error: any = {};
    if (type === "bike") {
      values.bikeNumber = values.vehicleNumber;
      error.vehicleNumber = validate.bikeNumber(values).bikeNumber;
    }
    if (type === "car") {
      values.carNumber = values.vehicleNumber;
      error.vehicleNumber = validate.carNumber(values).carNumber;
    }
    return error;
  },
  carNumber(values: ValueInterface) {
    const errors: CarNumberErrorsTypes = {};
    const bhCarNumberRegEx =
      "^[2-3][0-9][B][H](([1-9]\\d\\d\\d)|(\\d[1-9]\\d\\d)|(\\d\\d\\[1-9]\\d)|(\\d\\d\\d[1-9]))[A-HJ-NP-Z]{1,2}$";
    const carNumberRegex =
      "^(AN|AP|AR|AS|BR|CG|CH|DN|DD|DL|GA|GJ|HR|HP|JK|JS|JH|KA|KL|LD|MP|MH|MN|ML|MZ|NL|OR|OD|PB|PY|PN|RJ|SK|TG|TN|TS|TR|UA|UK|UP|WB)( *)( *|-)( *)([0-9]{1,2})( *)( *|-)( *)([a-zA-Z]{0,3})( *)( *|-)( *)([0-9]{1,4})$";
    let isBhCarNumberInvalid = false,
      isNormalCarNumberInvalid = false;
    if (!values.carNumber) {
      errors.carNumber = FIELD_ERROR_MESSAGE.carNumber.required;
    }
    if (!new RegExp(bhCarNumberRegEx, "i").test(cleanRegNo(values.carNumber))) {
      isBhCarNumberInvalid = true;
    }
    if (!new RegExp(carNumberRegex, "i").test(cleanRegNo(values.carNumber))) {
      isNormalCarNumberInvalid = true;
    }
    if (isBhCarNumberInvalid && isNormalCarNumberInvalid) {
      errors.carNumber = FIELD_ERROR_MESSAGE.carNumber.invalid;
    }
    return errors;
  },
  engineNumber(values: ValueInterface) {
    const errors: EngineNumberErrorsTypes = {};
    if (!values.engineNumber) {
      errors.engineNumber = FIELD_ERROR_MESSAGE.engine.required;
    } else if (
      cleanRegNo(values.engineNumber)?.length < 6 ||
      cleanRegNo(values.engineNumber)?.length > 26
    ) {
      errors.engineNumber = FIELD_ERROR_MESSAGE.engine.invalid;
    }
    return errors;
  },
  newCarChassisNumber(values: ValueInterface) {
    const errors: ChassisNumberErrorsTypes = {};
    if (!values.chassisNumber) {
      errors.chassisNumber = FIELD_ERROR_MESSAGE.chassis.required;
    } else if (
      cleanRegNo(values.chassisNumber)?.length < 6 ||
      cleanRegNo(values.chassisNumber)?.length > 26
    ) {
      errors.chassisNumber = FIELD_ERROR_MESSAGE.chassis.invalid;
    }
    return errors;
  },
  bikeNumber(values: ValueInterface) {
    const errors: BikeNumberErrorsTypes = {};
    const bhBikeNumberRegEx =
      "^[2-3][0-9][B][H](([1-9]\\d\\d\\d)|(\\d[1-9]\\d\\d)|(\\d\\d\\[1-9]\\d)|(\\d\\d\\d[1-9]))[A-HJ-NP-Z]{1,2}$";
    const bikeNumberRegex =
      "^(AN|AP|AR|AS|BR|CG|CH|DN|DD|DL|GA|GJ|HR|HP|JK|JS|JH|KA|KL|LD|MP|MH|MN|ML|MZ|NL|OR|OD|PB|PY|PN|RJ|SK|TG|TN|TS|TR|UA|UK|UP|WB)( *)( *|-)( *)([0-9]{1,2})( *)( *|-)( *)([a-zA-Z]{1,3})( *)( *|-)( *)([0-9]{1,4})$";
    let isBhBikeNumberInvalid = false,
      isNormalBikeNumberInvalid = false;
    if (!values.bikeNumber) {
      errors.bikeNumber = FIELD_ERROR_MESSAGE.bikeNumber.required;
    }
    if (
      !new RegExp(bhBikeNumberRegEx, "i").test(cleanRegNo(values.bikeNumber))
    ) {
      isBhBikeNumberInvalid = true;
    }
    if (!new RegExp(bikeNumberRegex, "i").test(cleanRegNo(values.bikeNumber))) {
      isNormalBikeNumberInvalid = true;
    }
    if (isBhBikeNumberInvalid && isNormalBikeNumberInvalid) {
      errors.bikeNumber = FIELD_ERROR_MESSAGE.bikeNumber.invalid;
    }
    return errors;
  },
  chassisNumber(values: ValueInterface) {
    const errors: BikeNumberErrorsTypes = {};
    const bikeNumberRegex = "^[a-zA-Z0-9_\\+\\-\\*\\.\\#\\&@\\$]{5,25}$";
    if (!values.bikeNumber) {
      errors.bikeNumber = FIELD_ERROR_MESSAGE.chassis.required;
    } else if (
      !new RegExp(bikeNumberRegex, "i").test(cleanRegNo(values.bikeNumber))
    ) {
      errors.bikeNumber = FIELD_ERROR_MESSAGE.chassis.invalid;
    }
    return errors;
  },
  pinCode(values: ValueInterface) {
    const errors: PinCodeErrorsTypes = {};
    const pinCodeRegex = "^[1-9][0-9]{5}$";
    if (!values.pinCode) {
      errors.pinCode = FIELD_ERROR_MESSAGE.pincode.required;
    } else if (
      !new RegExp(pinCodeRegex, "i").test(values.pinCode?.toString()?.trim())
    ) {
      errors.pinCode = FIELD_ERROR_MESSAGE.pincode.invalid;
    }
    return errors;
  },
  password(password: string) {
    return password && password.length >= 6;
  },
  // Regex to check only for numbers
  numeric(value: string) {
    const regex = /(^$)|(^\d+$)/;
    return value && regex.test(value);
  },
  url(value: string) {
    const urlRegEx =
      "^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$";
    const validURLRegex = new RegExp(urlRegEx, "i");
    return value && validURLRegex.test(value);
  },
  /**
   * Returns true only if a value is not empty
   */
  required(val: any): boolean {
    switch (typeof val) {
      case "string":
        return !!val.trim();
      case "number":
        return Number.isFinite(val);
      default:
        return !!val;
    }
  },
  address(value: string) {
    let error = "";
    if (!value || !value?.trim()) {
      error = FIELD_ERROR_MESSAGE.address.required;
    }
    return error;
  },
  city(value: string) {
    let error = "";
    if (!value || !value?.trim()) {
      error = FIELD_ERROR_MESSAGE.city.required;
    }
    return error;
  },
  gstNumber(values) {
    const errors: GSTErrorsTypes = {};
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9]{1}Z[0-9A-Z]{1}$/;
    const gstNumber = values?.gstNumber?.toUpperCase()?.trim();

    if (gstNumber && !gstRegex.test(gstNumber)) {
      errors.gstNumber = FIELD_ERROR_MESSAGE.gst.invalid;
    }
    return errors;
  }
};

export default validate;

export const registrationNumberRegex = [
  "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
  "^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
  "^[A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
  "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
  "^[A-Z][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
  "^[A-Z][A-Z][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
  "^[A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
  "^[A-Z][A-Z][0-9][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
  "^[A-Z][A-Z][0-9][0-9][A-Z][1-9][0-9][0-9][0-9][0-9]$",
  "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$",
  "^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
  "^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
  "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9]$",
  "^(GJ|DL|BR)[0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
  "^(GJ|DL|BR)[0-9][0-9][0-9][0-9][0-9]$",
  "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9]$",
  "^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$",
  "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
  "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
  "^[0-9][0-9][A-Z][A-Z][0-9][0-9]$",
  "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9]$",
  "^[0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
  "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
  "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z]$",
  "^[0-9][0-9][X][X][0-9][0-9][0-9][0-9][A-Z][A-Z]$"
];
